module.exports = __webpack_public_path__ + "img/payless2.8a65509d.gif";